import mask from 'jquery.maskedinput/src/jquery.maskedinput';
jQuery.cookie = function (b, j, m) { if (typeof j != "undefined") { m = m || {}; if (j === null) { j = ""; m.expires = -1 } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) { var f; if (typeof m.expires == "number") { f = new Date(); f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000)) } else { f = m.expires } e = "; expires=" + f.toUTCString() } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : ""; document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("") } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d } };

// указываем нужную форму
let currentForm = $('#popupModalDiscount');

// задаем состояние popup-окна
let noShowPopupNever = 0;
let noShowPopup = 1;

// функция открытитя модального окна
function openPopup(currentForm) {
  // показываем модальное окно
  currentForm.show();
  currentForm.prev('#closePopupModalOverlay').show();

  // Начинаем слушать клавишу Esc. При её нажатии, закарываем окно.
  $(document).on('keyup', function (e) {
    if (e.keyCode == 27) $('#closePopupModalOverlay, #popupModalDiscount').hide();
  });
}

function showPopup() {
  if (!$.cookie('noShowPopupNever') && noShowPopup == 0 && noShowPopupNever == 0) {
    openPopup(currentForm);
  }
}

function closePopup() {
  $.cookie('noShowPopupNever', true, {
    expires: 1,
    path: '/'
  });

  $('#closePopupModalOverlay, #popupModalDiscount').hide();
}

console.log('document.width = ' + $(document).width());

// Если форма существует и это не мобильное устройство, выполняем скрипт
if (currentForm.length && $(document).width() > 769) {
  // закрываем модальное окно
  $('.closePopupModal').click(function () {
    $('#closePopupModalOverlay, #popupModalDiscount').hide();
  });

  $('#userPopupContactPhone').mask("+7 (999) 999-99-99");

  if ($(document).width() < 1225) {

    setTimeout(function () {
      noShowPopup = 0;
      showPopup();
    }, 30000);

  } else {

    setTimeout(function () {
      noShowPopup = 0;
    }, 8000);
  }

  $(document).mousemove(function (e) {
    if (e.pageY <= 5 && noShowPopup == 0 && noShowPopupNever == 0) {
      showPopup();
      noShowPopup = 1;
    }
    setTimeout(function () { noShowPopup = 0; }, 30000);
  });

  $('#openPopupNext').click(function (e) {
    e.preventDefault();

    if ($(this).attr('id') === 'closePopupModal') {
      closePopup();
      noShowPopupNever = 1;
    }

    $('#popupContent').hide();
    $('#popupContentNext').show();

    $(this).attr('id', 'closePopupModal');
  });

  $('#closePopupModalOverlay').click(function () {
    closePopup();

    noShowPopup = 1;
    setTimeout(function () { noShowPopup = 0; }, 30000);
  });

  $('#closePopupModal').click(function (e) {
    e.preventDefault();

    closePopup();
    noShowPopupNever = 1;
  });

  $('#userPopupForm').submit(function (e) {
    e.preventDefault();
    const userPhone = $('#userPopupContactPhone').val();

    if (userPhone.length < 6) {

      $(".popup_error").text("Номер указан неверно!").css({ 'text-align': 'center' }).show().fadeOut(3000);
      return !1;

    } else {

      $.post('https://api.groupw.ru/mtrend/demands/join/person', {

        phone: userPhone,
        name: userName,
        comment: 'Cкидка на 300 рублей',
        demandSource: 'Заявка с сайта '

      }, function (response) {
        console.log(response);

        $(this).hide();
        $('#popupContent, #popupContentNext, #userPopupForm').hide();
        $('#popupContentSuccess').show();

        noShowPopupNever = 1;
        setTimeout(function () {
          closePopup();
        }, 2000);

        return false;
      });
    }
  });
}



// WEBPACK FOOTER //
// ./app/blocks/form-popup/form-popup.js